var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M10 3a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-3.116l-5.647 16H13a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h3.116l5.647-16H11a1 1 0 0 1-1-1z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }